export default {
  LOAD_LIST_EVENT_TYPE_FIELD(state, data) {
    state.listaEventTypeFields = data
  },
  PREPARE_TO_EDIT_EVENT_TYPE_FIELD(state, data) {
    state.eventTypeField = data
  },
  RESET_EVENT_TYPE_FIELD(state) {
    state.eventTypeField = {
      nome: '',
      tipoEvento: {
        id: '',
      },
      tipoCampo: '',
      obrigatorio: false,
      ordem: 0,
      ativo: true,
    }
  },
}
